import { alertMessagesArgsConfig } from '../../utils/event_constants';

export const metaDataTableActions = [
  {
    name: 'saveItemInMetaDataTable',
    label: 'Save Item in Meta Data Table',
    args: [
      {
        name: 'metaDataCollection',
        label: 'Select Meta Data Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'targetDataCollection',
        label: 'Select Target Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'metaDataMapping',
        label: 'Select Mapping',
        type: 'dropdown',
        optionsType: 'collectionMetaDataMappingApi',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'updateItemInMetaDataTable',
    label: 'Update Item in Meta Data Table',
    args: [
      {
        name: 'metaDataCollection',
        label: 'Select Meta Data Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'targetDataCollection',
        label: 'Select Target Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'metaDataMapping',
        label: 'Select Mapping',
        type: 'dropdown',
        optionsType: 'collectionMetaDataMappingApi',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'deleteItemInMetaDataTable',
    label: 'Delete Item in Meta Data Table',
    args: [
      {
        name: 'metaDataCollection',
        label: 'Select Meta Data Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'targetDataCollection',
        label: 'Select Target Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'metaDataMapping',
        label: 'Select Mapping',
        type: 'dropdown',
        optionsType: 'collectionMetaDataMappingApi',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'mapAllDataInMetaDataTable',
    label: 'Map All Data in Meta Data Table',
    args: [
      {
        name: 'metaDataCollection',
        label: 'Select Meta Data Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'targetDataCollection',
        label: 'Select Target Collection',
        type: 'dropdown',
        optionsType: 'collectionApi',
        options: [],
        value: '',
      },
      {
        name: 'metaDataMapping',
        label: 'Select Mapping',
        type: 'dropdown',
        optionsType: 'collectionMetaDataMappingApi',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
];
